// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nu-0";
export var assigneeDetails = "_nu-1";
export var assigneeInfo = "_nu-2";
export var dropdownContainer = "_nu-4";
export var dropdownImage = "_nu-5";
export var editAssigneeInfo = "_nu-3";
export var editAssigneeModalContainer = "_nu-6";
export var hidden = "_nu-8";
export var input = "_nu-7";